export enum OperatingSystemEnum {
    Windows = "Windows",
    Linux = "Linux",
    MacOS = "Mac OS",
    Android = "Android",
    IOS = "iOS",
    IPadOS = "IpadOS",
    ChromeOS = "ChromeOS",
    Other = "Other"
}